const data = {
  type: 'FillInTheBlank',
  id: 1,
  title: 'Listen and fill the blank with the correct words.',
  subTitle: 'Nghe và điền từ vào chỗ trống.',
  questionText: '',
  question: 'They are ___.',
  imageUrl: '',
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/82f96148-a085-444b-a87d-f6fdde78faa5.mp3',
  answers: [{ id: 1, answer: 'shoes' }],
};

export default data;
